import { AxiosPromise } from 'axios';
import { http } from 'services';
import * as Types from './types';

export const List = (params?: Types.IApi.List.Params): AxiosPromise<Types.IApi.List.Response> =>
  http.request.get('/api/results', { params });

export const Single = ({ id }: Types.IApi.Single.Params): AxiosPromise<Types.IApi.Single.Response> =>
  http.request.get(`/api/results/${id}`);

export const BulkDelete = (attemptIds: string[]): AxiosPromise<{ deleted: number }> =>
  http.request.delete('/api/results/bulk', { data: { attemptIds } });

export const Stats = ({ testId }: Types.IApi.Stats.Params): AxiosPromise<Types.IApi.Stats.Response> =>
  http.request.get(`/api/results/stats/${testId}`);

export const MyStats = (): AxiosPromise<Types.IApi.MyStats.Response> =>
  http.request.get('/api/results/me/stats');

export const Export = (testId: string): AxiosPromise =>
  http.request.get(`/api/results/export/${testId}`, { responseType: 'blob' });
